/*=========================================================================================
  File Name: moduleSpace.js
  Description: Space Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleProjectState.js'
import mutations from './moduleProjectMutations.js'
import actions from './moduleProjectActions.js'
import getters from './moduleProjectGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
